import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { phoneFormat } from '../utils/phoneFormat';

// <--------------- Formik --------------->

export const useLoginFormik = (
  login: (payload: { login: string; password: string }) => Promise<void>,
  loginPhone: (payload: { phone: string }) => Promise<void>,
  checkPhoneNumbers: boolean,
  fetchCheckSms: (payload: { phone: string; code: string }) => Promise<void>
) => {
  const intl = useIntl();
  return useFormik({
    initialValues: {
      login: '',
      password: '',
      role: 'ROLE_BUYER',
      acceptTerms: true,
      phone: '',
      smsCode: '',
    },
    validationSchema: () =>
      Yup.lazy((value: any) =>
        Yup.object().shape({
          login:
            value.role === 'ROLE_VENDOR'
              ? Yup.string().required(intl.formatMessage({ id: 'AUTH.INPUT.LOGIN_REQUIRED' }))
              : Yup.mixed(),
          password:
            value.role === 'ROLE_VENDOR'
              ? Yup.string().required(intl.formatMessage({ id: 'AUTH.INPUT.PASSWORD_REQUIRED' }))
              : Yup.mixed(),
          phone:
            value.role === 'ROLE_VENDOR'
              ? Yup.mixed()
              : Yup.string()
                  .test(
                    'check if phone length valid',
                    intl.formatMessage({ id: 'AUTH.INPUT.PHONE_REQUIRED' }),
                    (value) => phoneFormat(value)?.length === 10
                  )
                  .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
          smsCode: Yup.string().min(
            4,
            intl.formatMessage({ id: 'AUTH.VALIDATION.SMS_CODE.REQUIRED_FIELD' })
          ),
        })
      ),
    onSubmit: (values) => {
      if (checkPhoneNumbers) {
        fetchCheckSms({ phone: values.phone, code: values.smsCode });
      } else {
        values.role === 'ROLE_VENDOR'
          ? login({ login: values.login, password: values.password })
          : loginPhone({ phone: values.phone });
      }
    },
  });
};
